import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useWindowSizes } from 'v2/resources/hooks/useWindowSizes';
import { IPond } from 'v2/resources/types/ponds';

const useCycles = () => {
  const navigate = useHistory();

  const { isMobile, isTablet } = useWindowSizes();
  const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(
    null
  );
  const [openModalNursery, setOpenModalNursery] = useState<boolean>(false);
  const [dataModalNursery, setDataModalNursery] = useState({
    cycleId: 0,
    pondId: 0,
  });

  const handleNavigateOptions = (route: string, id: number, pond: IPond) => {
    navigate.push(route, {
      searchText: pond.description,
      pond: { ...pond },
    });
  };

  const handleOpenModalNursery = (cycleId: number, pondId: number) => {
    setDataModalNursery({
      cycleId,
      pondId,
    });
    setOpenModalNursery(true);
  };
  const handleCloseModalNursery = () => {
    setDataModalNursery({
      cycleId: 0,
      pondId: 0,
    });
    setOpenModalNursery(false);
  };

  const options = [
    {
      id: 1,
      title: 'Povoamento',
      route: '/populations',
    },
    {
      id: 2,
      title: 'Despescas',
      route: '/harvests',
    },
    {
      id: 3,
      title: 'Consumo',
      route: '/inputs',
    },
    {
      id: 4,
      title: 'Transferência',
      route: '/transfers',
    },
    {
      id: 5,
      title: 'Viveiro',
      route: '/cycles',
    },
  ];

  const handleOpenDropdown = (index: number) => {
    setOpenDropdownIndex((prev) => (prev === index ? null : index));
  };

  return {
    openDropdownIndex,
    options,
    openModalNursery,
    dataModalNursery,
    isMobile,
    isTablet,

    handleOpenModalNursery,
    handleNavigateOptions,
    handleOpenDropdown,
    handleCloseModalNursery,
  };
};

export default useCycles;
